import React, { useEffect, useState } from "react";
import styles from "./Payment.module.scss";
import Radio from "../../../Formik/Radio/Radio";
import { useSelector, useDispatch } from "react-redux";
import { formatPrice } from "../../../../../utils/utils";
import ErrorText from "../../../Formik/ErrorText/ErrorText";
import { getActiveCoinAction } from "../../../../../features/user/userSlice";
import { STATUS_CODE } from "../../../../../utils/constants";

const Payment = ({
  grandTotal,
  setPaymentMode,
  commonBalance,
  setSelectedCoin,
  setSelectedCoinBalance,
  coinOptions,
  cryptoPrices,
  btcBalance,
  ethBalance,
}) => {
  const dispatch = useDispatch();
  const walletBalance = useSelector((state) => state?.users?.walletBalance);

  const [balanceObj, setBalanceObj] = useState({});
  const [selectedPayment, setSelectedPayment] = useState("STBL Wallet");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [activeCoins, setActiveCoins] = useState([]);

  const fetchCoinOptions = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getActiveCoinAction());
      if (response.data.status === STATUS_CODE.successful) {
        setActiveCoins(response.data.data.coinList || []);
      }
    } catch (error) {
      setError("Error fetching coin options.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoinOptions();
  }, []);

  useEffect(() => {
    let data = [];
    walletBalance?.length > 0 &&
      walletBalance.forEach((element) => {
        data[element.account_type] = element.amount;
      });
    setBalanceObj(data);
  }, [walletBalance]);

  useEffect(() => {
    setPaymentMode("STBL Wallet");
  }, [setPaymentMode]);

  // const handlePaymentMode = (value) => {
  //   setSelectedPayment(value);
  //   setPaymentMode(value);

  //   if (value === "STBL Wallet") {
  //     setSelectedCoin(null);
  //     setSelectedCoinBalance(commonBalance);
  //     return;
  //   }

  //   const selectedCoin = activeCoins.find(
  //     (coin) => coin.coin_symbol === value
  //   );

  //   if (selectedCoin) {
  //     setSelectedCoin(selectedCoin);
  //     setSelectedCoinBalance(selectedCoin.balance);
  //   }
  // };

  const handlePaymentMode = (value) => {
  setSelectedPayment(value);
  setPaymentMode(value);
};


  return (
    <div className={styles.payment}>
      <div className={styles.payment_method}>
        <h6>Select Payment Method</h6>

        {/* STBL WALLET */}
        <label
          className={`${styles.labelpay} ${
            selectedPayment === "STBL Wallet" ? styles.selected : ""
          }`}
        >
          <Radio
            checked={selectedPayment === "STBL Wallet"}
            onChange={(e) => handlePaymentMode(e.target.value)}
            className={styles.radio}
            name="payment-method"
            value="STBL Wallet"
          />
          <h6>STBL Wallet</h6>
          <div className={styles.right_text}>
            <p>
              Bal: <span>${formatPrice(Number(commonBalance))}</span>
            </p>
          </div>
        </label>

        {/* CRYPTO COINS FROM API */}
        {activeCoins.map((coin) => (
          <label
            key={coin.id}
            className={`${styles.labelpay} ${
              selectedPayment === coin.coin_symbol ? styles.selected : ""
            }`}
          >
            <Radio
              checked={selectedPayment === coin.coin_symbol}
              onChange={(e) => handlePaymentMode(e.target.value)}
              className={styles.radio}
              name="payment-method"
              value={coin.coin_symbol}
            />
            <h6>{coin.coin_name}</h6>
            <div className={styles.right_text}>
              <p>
                Bal:{" "}
                <span>
                  {formatPrice(Number(coin.balance || 0))}
                </span>
              </p>
            </div>
          </label>
        ))}

        {error && <ErrorText>{error}</ErrorText>}
      </div>
    </div>
  );
};

export default Payment;
